import { TagsOutlined } from '@ant-design/icons';
import { Empty, Segmented } from 'antd';
import React, { useEffect, useState } from 'react';
import { BiSolidPackage } from 'react-icons/bi';
import { useNavigate } from 'react-router';
import slugify from 'slugify';
import Attributes from './tabs/attributes';
import CategoryProducts from './tabs/products';

const CategoryDetails = ({ category }) => {
  const navigate = useNavigate();
  const [detailsTab, setDetailsTab] = useState('category-attributes');

  useEffect(() => {
    if (category) {
      setDetailsTab('category-attributes');
    }
  }, [category?.id]);

  const onDetailsTabChange = (value) => {
    setDetailsTab(value);
    if (category?.title) {
      navigate(`/dashboard/categories/${slugify(category.title)}/${value}`);
    }
  };

  // TODO: moove to const file
  const segmentedOptions = [
    {
      label: 'Attributs',
      value: 'category-attributes',
      icon: <TagsOutlined />,
    },
    { label: 'Produits', value: 'category-products', icon: <BiSolidPackage /> },
  ];

  if (!category) {
    return (
      <div
        style={{
          height: '100%',
          minHeight: '500px',
          margin: '16px 0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Empty description="Sélectionnez une catégorie pour voir les détails" />
      </div>
    );
  }

  return (
    <div>
      <div>
        <h3 style={{ margin: 0 }}>Catégorie : {category?.title}</h3>
        {/* <Typography.Paragraph
          style={{ cursor: 'help' }}
          ellipsis={{
            rows: 1,
            tooltip: {
              title:
                'lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
              placement: 'topLeft',
              // overlayStyle: { maxWidth: '400px' },
            },
          }}
        >
          <b>Description :</b> lorem ipsum dolor sit amet consectetur
          adipisicing elit. Quisquam, quos. Sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
          exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur.
        </Typography.Paragraph> */}
      </div>
      <Segmented
        value={detailsTab}
        options={segmentedOptions}
        onChange={onDetailsTabChange}
        block
      />
      <div
        style={{
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto',
          scrollBehavior: 'smooth',
        }}
      >
        {detailsTab === 'category-attributes' && (
          <Attributes category={category} />
        )}
        {detailsTab === 'category-products' && (
          <CategoryProducts category={category} />
        )}
      </div>
    </div>
  );
};

export default CategoryDetails;
